/**
 * Created by or_p on 7/7/2016.
 */
import React, { Component } from 'react';
import BaseElementDialog from '../BaseElementDialog/BaseElementDialog';
import _ from 'lodash';
import TextField from 'material-ui/TextField';
import { getElementMethods } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { elementTypes } from 'crazyEditor/components/Elements/index';
import URI from 'urijs';
import EbayLinkChecker from 'shared/components/EbayLinkChecker';
import DebounceInput from 'react-debounce-input';


export default class HyperlinkDialog extends Component {
  constructor(props) {
    super(props);

    this.getElementProps = this.getElementProps.bind(this);
    this.state = this.getInitialStateFromProps(props);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.getInitialStateFromProps(nextProps));
  }

  getElementProps() {
    const { selectedElement } = this.props;
    let {href} = this.state;
    const uri = URI(href);
    if (!_.isEmpty(href) && _.isEmpty(uri.protocol())) {
      uri.protocol('https');
      href = uri.toString();
    }
    const elementMethods = getElementMethods(selectedElement.type);
    return elementMethods.getHyperlinkSetter(href);
  }

  getInitialStateFromProps(props) {
    const state = {};
    if (props.selectedElement) {
      state.href = _.get(props.selectedElement, 'data.href');
    }
    return state;
  }

  render() {
    const {open, onCancel, onAddUpdate, newElement } = this.props;
    const {href, linkValid} = this.state;
    return (
      <BaseElementDialog
        open={open}
        newElement={newElement}
        title={'Edit Link'}
        ref="baseElementDialog"
        inputValid
        onAddUpdate={() => onAddUpdate(this.getElementProps())}
        onCancel={() => onCancel()}
      >
        <div style={{width: '750px', margin: '20px auto'}}>
          <EbayLinkChecker onChange={(linkValid) => this.setState({linkValid})} href={href}/>
          <DebounceInput
            element = {TextField}
            errorStyle={{float: 'left'}}
            style={{width: '100%'}}
            value={href}
            hintText="Insert Link Here"
            floatingLabelText="Link URL"
            onChange={({target: {value}}) => {
              this.setState({href: value});
            }}
            debounceTimeout = {linkValid ? 2000 : undefined}
          />
        </div>
      </BaseElementDialog>);
  }
}
